import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import SubtopicTable from './pages/SubtopicTable';
import InsertQuiz from './pages/InsertQuiz';
import MathPreviewTest from './pages/MathPreviewTest';
import Quiz from './pages/Quiz';
import InsertLearningQA from './pages/InsertLearningQA';
import LearningPage from './pages/LearningPage.js';
import InsertClarify from './pages/InsertClarifyQA.js';
import ClarifyViewPage from './pages/ClarifyViewPage';
import ClarifyTopicsListPage from './pages/ClarifyTopicsListPage';
import UploadImageQA from './pages/UploadImageQA';
import InteractivePlaygroundPage from './pages/InteractivePlaygroundPage';
import MindMapReactDemo from './pages/MindMapReactDemo';
import EditLearningPage from './pages/EditLearningPage';
import InsertBlogLink from './pages/InsertBlogLink';
import InsertQuickReview from './pages/InsertQuickReview';
import QuickReviewPage from './pages/QuickReviewPage';
import CourseHome from './pages/CourseHome'; // <-- add this import
import ManageTopicsPage from './pages/ManageTopicsPage';
import AllPages from './pages/AllPages';
import RequireAuth from './components/RequireAuth'; // ✅ Required for protecting routes
import CourseHub from './pages/CourseHub';


function App() {
  return (
    <Router>
      <Routes>
        
        <Route
          path="/manage-topics"
          element={
            <RequireAuth>
              <ManageTopicsPage />
            </RequireAuth>
          }
        />

        {/* 👇 Redirect / to /login */}
        <Route path="/" element={<Navigate to="/login" />} />
        
        <Route path="/:alias" element={<CourseHome />} />

        {/* Demo / Debug */}
        <Route path="/  " element={<MindMapReactDemo />} />

        {/* ✅ Protected Routes */}
        <Route
          path="/quiz/:outlineId"
          element={
            <RequireAuth>
              <Quiz />
            </RequireAuth>
          }
        />
        <Route
          path="/quickreview/:outlineId"
          element={
            <RequireAuth>
              <QuickReviewPage />
            </RequireAuth>
          }
        />

        {/* 🔓 Public Route: Learn Internal (Removed RequireAuth) */}
        <Route path="/learn/:outlineId" element={<LearningPage />} />

        {/* Public Pages */}
        <Route path="/courses" element={<CourseHub />} />

        <Route path="/edit-learning" element={<EditLearningPage />} />
        <Route path="/all-pages" element={<AllPages />} />
        <Route path="/insert-blog-link" element={<InsertBlogLink />} /> 
        <Route path="/upload-image-qa" element={<UploadImageQA />} />
        <Route path="/insertquickreview" element={<InsertQuickReview />} />
        <Route path="/clarify-topics" element={<ClarifyTopicsListPage />} />
        <Route path="/clarify/:topicId" element={<ClarifyViewPage />} />
        <Route path="/insert-clarify" element={<InsertClarify />} />
        <Route path="/interactive-playground" element={<InteractivePlaygroundPage />} />
        <Route path="/insert-learning" element={<InsertLearningQA />} />
        <Route path="/math-test" element={<MathPreviewTest />} />
        <Route path="/insert-quiz" element={<InsertQuiz />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/:alias" element={<Dashboard />} />
        <Route path="/topics/:parentId" element={<SubtopicTable />} />

        {/* Fallback route */}
        <Route path="*" element={<div className="p-4 text-red-600">Page Not Found</div>} />
      </Routes>
    </Router>
  );
}

export default App;
